import { APP_INITIALIZER, Provider } from '@angular/core';
import { SignOutWaiterSubscriber } from '../../application/subscribers/sign-out-waiter.subscriber';

import { DOMAIN_SUBSCRIBERS } from '@features/service/infrastructure/provider/service.provider';

export const WAITER_PROVIDERS: Provider[] = [
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: SignOutWaiterSubscriber,
    multi: true
  },
  {
    provide: APP_INITIALIZER,
    deps: [DOMAIN_SUBSCRIBERS],
    useFactory: () => () => {},
    multi: true,
  },
];
